import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Policy } from "types/generated";

const PoliciesTableDescriptionCell = ({
  item: policy,
  ...cellProps
}: TableSimpleCellProps<Policy>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={policy.description} />
    </TableSimpleCell>
  );
};

export default PoliciesTableDescriptionCell;
